import { enableProdMode } from '@angular/core';
import { platformBrowserDynamic } from '@angular/platform-browser-dynamic';
import { ThresholdAppModule } from './app.module';
import { initOIDC } from './oidc-helper';

if (process.env.config.isProduction) {
	enableProdMode();
}

export function initAutoUpdate(autoUpdate: (bool) => void, error: (bool) => void) {

	let windowHash = window.location.hash;	
	let countHash = (windowHash.match(/#/g) || []).length;
	let legacyCount = 0;
	let nextCount = 0;

	if (window.location.href.indexOf("#/widget-frame?") >= 0) autoUpdate(false);
	if ((countHash === 0) || (countHash > 1)) autoUpdate(false);
	
	if ((window.location.hash.indexOf("#id_token") >= 0) && (countHash === 1) ) {
		if (sessionStorage.getItem('authorizationData') !== null) {
			let bearer = 'Bearer ' + sessionStorage.getItem('authorizationData');

			fetch('/api/experience',
				{
					headers: {
						'Authorization': bearer,
						'Content-Type': 'application/json'
					}
				}
			)
			.then(response => response.json())
			.then(experiences => { 
				experiences.map((experience: any) => {
					let celineVersion;
					if (experience.tags) celineVersion = experience.tags.celineVersion ? experience.tags.celineVersion : 1; 
					else celineVersion = 1;
					if (celineVersion === 1) legacyCount++;
					else nextCount++;			
				});

				if (nextCount > legacyCount) { 
					autoUpdate(true)
				}
				else { 
					autoUpdate(false)
				}

			});
		} else {
			autoUpdate(false)
		}
	} else {
		autoUpdate(false)
	}
}

/**
 * 
 * @param success 
 * @param error 
 */
function initConfigurations(success: Function, reject: Function) {
	fetch('/api/configuration').then(response => {
		if (response.ok) {
			return response.json();
		} else {
			reject(new Error('error'))
		}
	})
	.then(function (data) {
		success(data)
	})
	.catch((error) => {
		reject(error)
	});
}

// Instana
ineum('meta', 'celine', `${process.env.config.pkgVersion}`);

ineum('ignoreUrls', [
	/\/bam.nr-data.net.+/i,
	/\/unreadMessages.+/i
]);

(function(global){
    function noticeError(e) {
		console.log('Error:', e);
    }
    global['newrelic'] = {
		noticeError: noticeError
    }
})(window)
 
setTimeout(() => {

	initConfigurations((success: any) => {
		if (success) {
			let responseData = success;
			window['__CONFIGURATION'] = JSON.stringify(responseData);
			if (!window['__NOT_USE_AUTHENICATION']) {
				initOIDC((authenticated: any) => {
					if (authenticated) {

						// initAutoUpdate((autoUpdate: any) => {
						// 	if (autoUpdate) {
						// 		window.location.href = '/v2'; 
						// 	}
						// 	else {
								platformBrowserDynamic().bootstrapModule(ThresholdAppModule);
							// }
						// }, function (error: any) {
						// 	alert("authentication, please investigate.");
						// });

						
					}
				}, function (error: any) {
					alert("authentication, please investigate.");
				});
			}
			else {

				initAutoUpdate((autoUpdate: any) => {
					// console.log('autoUpdate', autoUpdate);
					// if (autoUpdate) {
					// 	// window.location.replace("/2");
					// 	window.location.href = '/v2'; 
					// }
					// else {
						platformBrowserDynamic().bootstrapModule(ThresholdAppModule);
					// }
				}, function (error: any) {
					alert("authentication, please investigate.");
				});

				// platformBrowserDynamic().bootstrapModule(ThresholdAppModule);
			}


		}
	}, function(error: any) {
		console.error("An error has occurred: ", error);
	});

}, 200);


// WEBPACK FOOTER //
// node_modules/angular2-template-loader!./~/angular-router-loader/src!./src/app/threshold/main.ts